import http from '../utils/http';

function contact(data) {
  return http.post('live_reserve', data);
}

export default contact;
